import React from 'react'

export default function PageHero({
  title,
  className = '',
}: {
  title: React.ReactNode
  className?: string
}) {
  return (
    <section className="bg-blueGreen pt-24 pb-6 md:pt-28 md:pb-7 lg:pt-32 lg:pb-8">
      <div className="text-center px-4 max-w-4xl mx-auto">
        <h1
          className={`font-medium text-xl md:text-2xl lg:text-3xl text-white leading-snug md:leading-tight ${className}`}
        >
          {title}
        </h1>
      </div>
    </section>
  )
}
